var map = {
	"./card1.png": 1933,
	"./card10.png": 8618,
	"./card11.png": 6471,
	"./card12.png": 7550,
	"./card13.png": 1744,
	"./card14.png": 49,
	"./card15.png": 5265,
	"./card16.png": 3557,
	"./card17.png": 8979,
	"./card18.png": 2641,
	"./card19.png": 7300,
	"./card2.png": 2616,
	"./card20.png": 9045,
	"./card21.png": 7439,
	"./card22.png": 8626,
	"./card23.png": 5538,
	"./card24.png": 9093,
	"./card3.png": 1315,
	"./card4.png": 9201,
	"./card5.png": 4163,
	"./card6.png": 1666,
	"./card7.png": 5579,
	"./card8.png": 2396,
	"./card9.png": 8042
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8812;